import Modal from 'bootstrap/js/dist/modal';

const resolve = (target) => {
  if (!target) return null;
  if (typeof target === 'string') return document.querySelector(target);

  return target;
};

export const show = (target) => {
  const element = resolve(target);
  if (!element) return;

  Modal.getOrCreateInstance(element).show();
};

export const hide = (target) => {
  const element = resolve(target);
  if (!element) return;

  const instance = Modal.getInstance(element) ||
    (element.classList.contains('show') ? Modal.getOrCreateInstance(element) : null);
  instance?.hide();
};

export const hideAll = () => {
  document.querySelectorAll('.modal.show').forEach((element) => hide(element));
};

export const dispatch = (target, action) => {
  if (action === 'show') show(target);
  if (action === 'hide') hide(target);
};
